// Matrix homeserver the app talks to. Client-Server API is served directly from
// this origin (no .well-known delegation — verified). Login flow: m.login.password.
// Web only (local test runs): localStorage key `helm_hs` overrides the homeserver, so the UI can be
// driven against scripts/mock-homeserver.js in a browser. Native builds ignore this.
import { Platform } from 'react-native';

// Local test runs only. http://localhost:8082/?mock points this browser at scripts/mock-homeserver.js (a fake
// agent with approvals waiting); http://localhost:8082/?real points it back at the real server. Honoured on
// localhost only, so a link to the hosted app can never move someone to another server. Switching forgets
// the sign-in kept in this browser, because a session of one server means nothing to the other.
function localSwitch(): void {
  if (Platform.OS !== 'web' || typeof window === 'undefined' || typeof localStorage === 'undefined') return;
  const host = window.location.hostname;
  if (host !== 'localhost' && host !== '127.0.0.1') return;
  const q = new URLSearchParams(window.location.search);
  if (!q.has('mock') && !q.has('real')) return;
  const to = q.has('mock') ? 'http://localhost:8765' : null;
  if (to !== localStorage.getItem('helm_hs')) { localStorage.removeItem('mx_session'); localStorage.removeItem('mx_cache_v1'); }
  if (to) localStorage.setItem('helm_hs', to); else localStorage.removeItem('helm_hs');
  q.delete('mock'); q.delete('real');
  const rest = q.toString();
  window.history.replaceState(null, '', window.location.pathname + (rest ? `?${rest}` : ''));
}
try { localSwitch(); } catch { /* no storage */ }

let override: string | null = null;
try { if (Platform.OS === 'web' && typeof localStorage !== 'undefined') override = localStorage.getItem('helm_hs'); } catch { /* no storage */ }
export const MATRIX_HS = override || 'https://matrix.getfxm.ai';
export const HS_LABEL = MATRIX_HS.replace(/^https?:\/\//, '');
// The one call Helm makes outside Matrix: inviting someone by email needs the platform to send the mail and
// to add them to the room on first login (helm-infra docs/email-invites.md). Web test runs use the mock's stub.
export const INVITE_API = override ? `${override}/helm` : 'https://api.getfxm.ai/helm';
export const INVITE_BOT = '@helm-invites:matrix.getfxm.ai';
